import { render, staticRenderFns } from "./Realms.vue?vue&type=template&id=93301036&scoped=true"
import script from "./Realms.vue?vue&type=script&lang=js"
export * from "./Realms.vue?vue&type=script&lang=js"
import style0 from "./Realms.vue?vue&type=style&index=0&id=93301036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93301036",
  null
  
)

export default component.exports